import { LockIcon } from "@chakra-ui/icons";
import { Box, Center, Text } from "@chakra-ui/react";
import { StatCardProps } from "@ui/application";

export const LockedStatCard = (props: Omit<StatCardProps, "value">) => {
  const { title, children, colorScheme, ...rest } = props;

  return (
    <Box
      as="dl"
      bg={"white"}
      p="6"
      rounded="lg"
      shadow="md"
      _hover={{
        transform: "scale(1.05)",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      {...rest}
    >
      <Text as="dt" color={`${colorScheme || "blue"}.500`} fontWeight="bold">
        {title}
      </Text>
      <Center>
        <Box as={LockIcon} color="gray.300" h="12" w="12" my="4" />
      </Center>
      <Text as="dd" color={"blueGray.600"} fontSize="sm">
        {children}
      </Text>
    </Box>
  );
};
